












































































import { Component, Vue } from 'vue-property-decorator';
import { refsService } from '@/app/shared/refs.service';
import { BrcodeType } from '@/app/shared/enums';
import DataTableInstallmentsSimpleSelection from '@/app/shared/components/data-tables/installments-simple-selection.vue';
import { DialogCancelContractMarkOff } from '@/app/shared/components';
@Component({
  components: {
    DataTableInstallmentsSimpleSelection,
    DialogCancelContractMarkOff,
  },
})
export default class DialogDevolutionComponent extends Vue {
  private loading = false;
  private dialog = false;
  private dialogCancel = false;
  private refundPaymentMethod = 0;
  private pixMethod: BrcodeType = 0;
  private showBankDataForm = false;
  private numberCredit = 0;
  private creditAmount = 0;
  private amount = 0;
  private numberInstallment = 0;
  private valueTab = '';
  private get refs() {
    return refsService;
  }

  private get rules() {
    return this.refs.static.rules;
  }

  private get getInstallments() {
    const result = this.refs.modules.contract.installmentList
      .filter(
        (installment) =>
          this.refs.enums.InstallmentStatus[installment.Status].toString() ==
            this.refs.enums.InstallmentStatus.Paid.toString() &&
          this.refs
            .moment(installment.OriginalDueDate, 'YYYY/MM/DD')
            .format('YYYY/MM/DD') >=
            this.refs.moment(new Date(), 'YYYY/MM/DD').format('YYYY/MM/DD')
      )
      .sort((a, b) =>
        (a.OriginalDueDate || new Date()) < (b.OriginalDueDate || new Date())
          ? -1
          : 1
      );
    this.numberCredit = 0;
    this.creditAmount = 0;

    result.map((installment) => (this.creditAmount += installment.Value || 0));
    this.numberCredit = result.length;
    this.numberInstallment = this.numberCredit;
    this.amount = this.creditAmount;

    return result;
  }
  private cleanValues() {
    this.numberCredit = 0;
    this.amount = 0;
    this.creditAmount = 0;
    this.numberInstallment = 0;
  }

  private async showBankData() {
    return false;
  }
}
